// Main Application

import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import * as Motion from 'motion/react';
import DialogBox from './components/DialogBox/DialogBox';
import SidebarNavigation from './components/SidebarNavigation';
import UserProfileSidebarItem from './components/UserProfileItem';
import useCurrentDeviceId from './hooks/useCurrentDeviceId';
import logo from 'url:./static/images/na-logo-dark-small.png';
import { animationStaggeredContainer } from './animations';
import { version } from '../package.json';
import './styles/app.scss';

const { motion } = Motion;


const App = () => {
  const { currentDeviceId } = useCurrentDeviceId();
  const location = useLocation();

  return (
    <div className="app-container">
      <div className="app-wrapper">
        <DialogBox/>

        <div className="app-sidebar">
          <div className="sidebar-header">
            <img src={logo} className="app-logo" alt="logo"/>
            <h1 className="app-title">
              Conductor
            </h1>
          </div>

          <SidebarNavigation/>

          <div>
            <p className="current-device-id">
              <b>Conductor ID:</b> {currentDeviceId}
            </p>
          </div>

          <div className="sidebar-footer">
            <UserProfileSidebarItem/>
          </div>
        </div>


        <motion.div
          key={location.pathname}
          variants={animationStaggeredContainer}
          initial="hidden"
          animate="show"
          className="screen-wrapper">
          <Outlet/>
        </motion.div>

        <p className={'app-version'}>
          App Version: {version}
        </p>
      </div>
    </div>
  );
};

export default App;
